import React from "react";
import { SITE_CONTENT } from "../content";

const IntroSection = () => {
  const { title, paragraphs } = SITE_CONTENT.pages.homePage.introSection;

  const cards = [
    {
      num: "01.",
      title: "Taste & Dependability",
      text: paragraphs[0],
    },
    {
      num: "02.",
      title: "Outdoor Kitchen & Crew",
      text: paragraphs[1],
    },
    {
      num: "03.",
      title: "Tailored To Every Event",
      text: paragraphs[2],
    },
    {
      num: "04.",
      title: "Salem Base & Tamil Nadu Wide",
      text: paragraphs[3],
      extra: "Salem · Chennai · Coimbatore",
    },
  ];

  return (
    <section className="bg-[#FAF6EE] py-16 sm:py-20 lg:py-24 relative overflow-hidden" id="about-intro">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Section Heading - Smaller, refined & professional font */}
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-[28px] font-serif font-medium text-[#0f1f14] leading-snug tracking-tight">
            {title}
          </h2>
          <div className="w-14 sm:w-16 h-[2.5px] bg-gradient-to-r from-[#D4AF37] to-[#E8A040] mx-auto mt-3.5 rounded-full" />
        </div>

        {/* 2x2 Grid of Cards - All default white, Green on Hover Only */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 lg:gap-7">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className="group p-6 sm:p-7 rounded-2xl bg-white border border-[#e5ded3] shadow-[0_3px_18px_rgba(0,0,0,0.03)] hover:bg-[#092212] hover:border-[#1b4329] hover:shadow-[0_12px_32px_rgba(9,34,18,0.2)] hover:-translate-y-1 transition-all duration-300 flex flex-col justify-between cursor-default"
            >
              <div>
                {/* Card Title - smaller & matching header font */}
                <h3 className="font-serif font-medium text-base sm:text-[17px] lg:text-[18px] text-[#b8731b] group-hover:text-[#F0C068] mb-2.5 sm:mb-3 tracking-normal leading-snug transition-colors duration-300">
                  <span className="mr-1.5">{card.num}</span>
                  {card.title}
                </h3>

                {/* Card Body Text - smaller, crisp & highly readable */}
                <p className="font-sans text-[13px] sm:text-[13.5px] lg:text-[14px] text-[#4b5563] group-hover:text-[#d6ded8] leading-[1.65] font-normal transition-colors duration-300">
                  {card.text}
                </p>
              </div>

              {card.extra && (
                <div className="mt-4 pt-3 border-t border-[#f0eae0] group-hover:border-white/10 flex items-center justify-between text-xs transition-colors duration-300">
                  <span className="text-[#22c55e] font-medium">
                    {card.extra}
                  </span>
                  <a
                    href="#service-areas"
                    className="text-[#b8731b] group-hover:text-[#F0C068] font-semibold hover:underline"
                  >
                    View cities &rarr;
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default IntroSection;
